export const getCurrentUser = () => {
  const userData = sessionStorage.getItem("persist:vf_userSession");
  if (!userData) return null;

  const parsed = JSON.parse(userData);
  return parsed?.user ? JSON.parse(parsed.user) : null;
};